import { faPen, faTrash } from "@fortawesome/pro-solid-svg-icons";

import { CroppedImagePreview } from "@/components/ui-v2";
import { TileButton } from "@/components/ui-v2/Tiles/common/TileButton";
import {
  TileBase,
  TileBaseProps,
} from "@/components/ui-v2/Tiles/TileBase/TileBase";
import { Rectangle } from "@/types";

import { Icon, TileButtonsContainer } from "../..";

interface FileSelectPreviewListImageTileProps extends TileBaseProps {
  src: string;
  alt?: string;
  isEditable?: boolean;
  cropWindow?: Rectangle;
  onAction: (event: React.MouseEvent, action: string) => void;
}

const BottomLeftEl = (props: {
  onAction: (event: React.MouseEvent, action: string) => void;
  isEditable: boolean;
}) => {
  const { onAction, isEditable } = props;

  const handleAction = (action: string) => (e: React.MouseEvent) => {
    e.stopPropagation();
    onAction(e, action);
  };

  return (
    <TileButtonsContainer>
      <TileButton
        aria-label="Delete"
        data-testid="btn-delete"
        onClick={handleAction("DELETE")}
      >
        <Icon icon={faTrash} fontSize="small" />
      </TileButton>
      {isEditable && (
        <TileButton
          aria-label="Edit"
          data-testid="btn-edit"
          onClick={handleAction("EDIT")}
        >
          <Icon icon={faPen} fontSize="small" />
        </TileButton>
      )}
    </TileButtonsContainer>
  );
};

export const FileSelectPreviewListImageTile = (
  props: FileSelectPreviewListImageTileProps,
) => {
  const {
    src,
    alt = "",
    isEditable = false,
    cropWindow,
    onAction,
    ...rest
  } = props;

  return (
    <TileBase
      slots={{
        bottomLeftEl: BottomLeftEl,
      }}
      slotProps={{
        bottomLeftEl: { onAction, isEditable },
      }}
      {...rest}
    >
      {cropWindow ? (
        <CroppedImagePreview cropWindow={cropWindow} src={src} alt={alt} />
      ) : (
        <img src={src} alt={alt} />
      )}
    </TileBase>
  );
};
